import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { BlockedTimeStore } from './blocked-time.store';
import { BlockedTimeState } from './blocked-time.state';

@Injectable({ providedIn: 'root' })
export class BlockedTimeQuery extends QueryEntity<BlockedTimeState> {
  constructor(protected override store: BlockedTimeStore) {
    super(store);
  }
}
